import { createSlice } from '@reduxjs/toolkit';
//
import { get_LS_Item as getToken } from '@/plugin/tools/tools.js';
//
function initLoginState() {
    // 初次判断是否已经登录
    if (getToken('refresh_token')) {
        return true
    }
    return false
}
//
//
let loginTimeStamp = localStorage.getItem('account_LoginTime')
export const loginStateSlice = createSlice({
    name: 'loginState',
    initialState: {
        loginState: initLoginState(),
        loginTimeStamp: loginTimeStamp
    },
    reducers: {
        setLoginStateTrue: (state) => { state.loginState = true },
        setLoginStateFalse: (state) => { state.loginState = false },
        setLoginStamp: (state, data) => {
            // state.loginState
            // console.log('001 Redux', '设置账户登录时的时间戳' , '第一个参数:', state, "第二个参数:", data);
            /*
                接收的第一个参数: Proxy(Object) {i: 0, A: {…}, P: false, I: false, R: {…}, …}[[Handler]]: null[[Target]]: null[[IsRevoked]]: true 
                接收的第二个参数: {type: 'loginState/setLoginStamp', payload: dispatch 发送的参数}
             */
            state.loginTimeStamp = data.payload
            // console.log(1000, 'store:setLoginStamp:', state.loginTimeStamp);
        }
    }
})
export const {
    setLoginStateTrue, setLoginStateFalse,  // 设置登录状态: 是否登录
    setLoginStamp            // 设置账户登录时的时间戳
} = loginStateSlice.actions  // 操作状态的动作
export default loginStateSlice.reducer;

